












































































// import config from './test.js'configSkin
// import { getUIConfig } from '@/lib/photograph-flow/flow/configSkin'
import { Vue, Component } from 'vue-property-decorator'
import { Button } from 'mand-mobile'
import { cutString } from '@/lib/common-util'
import store from '@/store'

@Component({ components: { [Button.name]: Button } })
export default class Home extends Vue {
  bizToken: any = null
  isAllowUpload: boolean = true
  pcTipsPage: any = {}
  titleTexta: any = 'Liveness Detection'
  isLoading: boolean = true
  isLoadingTime: any = null

  cutString(str: string, length: number) {
    return cutString(str, length);
  }

  async isConfigCon() {
    try {
      // const data = await getUIConfig({
      //   locale: this.$root.$i18n.locale || 'en',
      //   token: this.bizToken,
      //   signatureId: '',
      // })
      // setTimeout(() => {
        let resultSkinCon: any = sessionStorage.getItem('UIConfigObj') || false
        if (!resultSkinCon) {
          resultSkinCon = '{}'
          this.isLoadingTime = setTimeout(() => {
            this.isLoading = false
          }, 10000)
          return
        }
        clearTimeout(this.isLoadingTime)
        resultSkinCon = JSON.parse(resultSkinCon) || {}
        this.titleTexta = (resultSkinCon.titleText && resultSkinCon.titleText.length > 0) ? resultSkinCon.titleText : 'Liveness Detection'
        localStorage.setItem('titleText', this.titleTexta)
        sessionStorage.setItem('resultTextCon', JSON.stringify(resultSkinCon))
        this.pcTipsPage = resultSkinCon.pcTipsPage || {}
        this.isLoading = false
      // }, 0)
    } catch (error) {
      console.log(error)
    }
  }

  startHandler() {
    let query: any = {
      biz_token: this.bizToken,
      fromName: this.$route.query.from,
      eventTimestamp: new Date().getTime(),
    }
    if (this.$route.query.userId) {
      query.userId = this.$route.query.userId
    }
    this.$router.push({ name: 'webFaceImageV2', query})
  }
  mounted() {
    store.bizToken = this.$route.query.biz_token as string
    this.bizToken = this.$route.query.biz_token
    this.isConfigCon()
    window.addEventListener('setItem', () => {
      this.isConfigCon()
    })
    if (!this.bizToken) {
      this.isAllowUpload = false
      return
    }
  }
  beforeDestroy() {
    window.removeEventListener('setItem', () => {
      console.log('removeSetItem')
    })
  }
}
